module.exports = __webpack_public_path__ + "static/feature-recap-04-7372dbb393906f4868cf595448f3073c.svg";